module.exports = __webpack_public_path__ + "static/media/eat-onboarding.218d1c39.png";